import { IconFromSVG } from '@src/components/icon/utils';
import type { SidebarSectionProps } from '@src/scenario-editor/render-utils/types';

export const SidebarSection= ({ items, title, searchQuery, onDragStart }: SidebarSectionProps) => {
  const filteredItems = items.filter(item => item.title.toLowerCase().includes(searchQuery.toLowerCase()));
  return filteredItems.length ? (
    <div className="mt-2">
      <h3 className="text-sm font-bold py-2">{title}</h3>
      <ul className="list-none grid grid-cols-1 gap-2">
        {filteredItems.map((item, index) => {
          return (
          <li key={index} className="cursor-all-scroll">
            <item.renderer
              data-testid={`sidebar=>${item.nodeType}`}
              key={index}
              // LF360-1823 (#117): у макеті картки пласкі; тінь лишалася тільки на картках без свого кольору,
              // через що If Condition / Behavior Rules виглядали інакше за сусідів.
              className="cursor-all-scroll"
              onDragStart={(event) => onDragStart(event, JSON.stringify(item))}
              draggable
              style={{
                backgroundColor: item?.bgColor,
              }}
            >
              {/* LF360-1823 (#113): 16px за рев'ю Максима. Разом із p-2 + border-2 у MenuItem
                  це дає висоту айтема рівно 36px (#112) - висоту НЕ виставляти окремо. */}
              <IconFromSVG className="mr-2 w-4 h-4 flex justify-center items-center" svg={item.icon} />
              {/* LF360-1823 (#112): text-sm дає line-height 20px, і без цього саме текст, а не іконка,
                  визначав би висоту рядка — айтем виходив би 40px замість 36. leading-4 (16px)
                  зрівнює line box з іконкою. */}
              <span className="leading-4">{item.title}</span>
            </item.renderer>
          </li>
        )})}
      </ul>
    </div>
  ) : null;
}
